import React, { FC, useCallback } from 'react';
import { Breadcrumbs, BreadcrumbsItem } from 'fronton-react';
import { useSelector } from 'react-redux';
import { sectionStyle as commonSectionStyle } from 'common/styles/section';
import { useBreakpoints } from 'common/hooks/use-breakpoints';
import { getBreadcrumbs } from 'features/page-model/ducks/get-model';
import { cx } from 'linaria';
import { analyticsUtils } from 'utils';
import { sectionStyle } from './style';
import { filterBreadcrumbs } from './utils/filter-breadcrumbs';

export const DATA_QA_BREADCRUMB = 'breadcrumb';

export const BreadcrumbsSection: FC = () => {
  const breadcrumbsModel = useSelector(getBreadcrumbs) || [];
  const { smMobile } = useBreakpoints() || {};
 
  const breadcrumbs = filterBreadcrumbs(breadcrumbsModel, Boolean(smMobile));

  const sendGA = useCallback((label: string) => {
    analyticsUtils.sendEvent('GA:clickButton', {
      elementType: 'button', // const
      elementBlock: 'shopPage', // const
      elementText: label,
      elementName: 'breadcrumbs', // const название блока
    });
  }, []);

  return (
    <section className={cx(sectionStyle, commonSectionStyle)}>
      <Breadcrumbs>
        {breadcrumbs.map(breadcrumb => (
          <BreadcrumbsItem
            key={breadcrumb.label}
            onClick={() => sendGA(breadcrumb.label)}
            href={breadcrumb.link}
            data-qa={DATA_QA_BREADCRUMB}>
            {breadcrumb.label}
          </BreadcrumbsItem>
        ))}
      </Breadcrumbs>
    </section>
  );
};
